// pageType definition from Pixall
// https://pixall-qa-api.prod.analytics.dealer.com/docs#pagetype-required

const pageAliasMapping = [
	{
		matcher: '(?:^AUTO_.*_DETAILS|.*_DETAILS.*)$',
		data: {
			pageType: 'vdp'
		}
	},
	{
		matcher:
			'.*(?:INVENTORY_LISTING|INVENTORY_FEATURED|INVENTORY_SEARCH|_INVENTORY|SMARTBROWSE|FACETBROWSE_AJAX).*',
		data: {
			pageType: 'vlp'
		}
	},
	{
		matcher: '.*(?:CONTACT|QUICK_QUOTE|INVENTORY_FINDER|CARFINDER).*',
		data: {
			pageType: 'contact'
		}
	},
	{
		matcher: '.*404.*',
		data: {
			pageType: 'error'
		}
	},
	{
		matcher: '.*(?:ABOUT|BLOG|EMPLOYMENT|NEWS|STAFF|TESTIMONIALS).*',
		data: {
			pageType: 'about'
		}
	},
	{
		matcher: '.*(?:COMPARE|FAVORITES).*',
		data: {
			pageType: 'comparison'
		}
	},
	{
		matcher: '.*(?:DIRECTIONS|LOCATIONS).*',
		data: {
			pageType: 'directions'
		}
	},
	{
		matcher: '.*FINANCE.*',
		data: {
			pageType: 'finance'
		}
	},
	{
		matcher: '.*(?:INCENTIVES|SPECIALS).*',
		data: {
			pageType: 'specials'
		}
	},
	{
		matcher: 'INDEX',
		data: {
			pageType: 'home'
		}
	},
	{
		matcher: '.*PARTS.*',
		data: {
			pageType: 'parts'
		}
	},
	{
		matcher: '.*(?:SERVICE|BODYSHOP).*',
		data: {
			pageType: 'service'
		}
	},
	{
		matcher: '.*SHOWROOM.*',
		data: {
			pageType: 'showroom'
		}
	},
	{
		matcher: '.*',
		data: {
			pageType: 'other'
		}
	}
];

/**
 * Returns the pageType mapping given the DDC page alias.
 * Mapping keys are treated as regular expressions used to test
 * the current page alias for a match.
 *
 * @param {string} pageAlias The DDC page alias
 * @returns {string} The pageType mapping, must return a value, default is 'other'
 */
function mapPageAlias(pageAliasIn) {
	let mapping;
	let pageType;

	if (typeof pageAliasIn === 'string' && pageAliasIn !== '') {
		const pageAlias = pageAliasIn.toUpperCase();
		mapping = Object.entries(pageAliasMapping).find((obj) =>
			pageAlias.match(obj[1].matcher)
		);
		pageType = mapping[1]?.data?.pageType;
	}

	return pageType || null;
}

export default mapPageAlias;
